// Widget 自有 complete 弹窗 — 不复用 src/components/complete，避免共享样式被改动。
// 通过 LoginCustomProvider 注入跟登录抽屉同一份 customization（theme/text），
// 让两个弹窗用完全相同的 CSS 变量和样式标记，从根源上保持一致。
import { Modal } from "@/components";
import { ConfigProvider } from "antd";
import { LoginCustomProvider, type LoginCustomization } from "../customization";
import Content from "./content";
import staticRender from "./staticRender";
import type { StaticRenderModalConfig } from "@/components";

interface CompleteOptions {
  customization: LoginCustomization;
  rootClass: string;
  antdToken: Record<string, unknown>;
}

const complete = async (sessionId: string, options: CompleteOptions) => {
  const { customization, rootClass, antdToken } = options;
  const completeRootClass = `${rootClass} peblla-complete-drawer`;
  const headerTitle = customization.text?.completeTitle ?? "Join Our Loyalty Program";

  return new Promise((resolve) => {
    if (window.innerWidth > 768) {
      Modal.alert({
        title: headerTitle,
        footer: null,
        width: 500,
        className: completeRootClass,
        closable: true,
        onCancel: () => resolve("cancel"),
        content: (props: StaticRenderModalConfig) => (
          <ConfigProvider wave={{ disabled: true }} theme={{ token: antdToken }}>
            <LoginCustomProvider value={customization}>
              <Content
                {...props}
                sessionId={sessionId}
                onCancel={() => {
                  props?.onCancel?.();
                  resolve("cancel");
                }}
                onOk={() => {
                  resolve("complete");
                  props?.onCancel?.();
                }}
              />
            </LoginCustomProvider>
          </ConfigProvider>
        ),
      });
    } else {
      staticRender({
        title: headerTitle,
        open: true,
        placement: "bottom",
        closable: true,
        rootClassName: completeRootClass,
        zIndex: 1010,
        maskClosable: false,
        onClose: () => resolve("cancel"),
        content: (modalProps) => (
          <ConfigProvider wave={{ disabled: true }} theme={{ token: antdToken }}>
            <LoginCustomProvider value={customization}>
              <Content
                sessionId={sessionId}
                onCancel={() => {
                  /* @ts-ignore */
                  modalProps?.onClose?.();
                  resolve("cancel");
                }}
                onOk={() => {
                  resolve("complete");
                  /* @ts-ignore */
                  modalProps?.onClose?.();
                }}
              />
            </LoginCustomProvider>
          </ConfigProvider>
        ),
      });
    }
  });
};

export default complete;
